import { render } from "./index.vue?vue&type=template&id=412c93ae"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ProductionDetails/OfferDetails/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "412c93ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('412c93ae', __exports__)) {
    api.reload('412c93ae', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=412c93ae", () => {
    api.rerender('412c93ae', render)
  })

}


export default __exports__